export default __webpack_public_path__ + "static/media/gallery-8-4.a2f90f3c.webp";